import { Controller } from "@hotwired/stimulus"

// Copies a static string (data-clipboard-text-value) to the clipboard and
// briefly swaps the button label to "Copied!". Falls back to a hidden
// textarea + execCommand on non-secure contexts where navigator.clipboard
// is unavailable.
export default class extends Controller {
  static values = { text: String }
  static targets = ["label"]

  copy() {
    const done = () => this.flash()
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(this.textValue).then(done).catch(() => this.fallbackCopy(done))
    } else {
      this.fallbackCopy(done)
    }
  }

  fallbackCopy(done) {
    const ta = document.createElement("textarea")
    ta.value = this.textValue
    ta.setAttribute("readonly", "")
    ta.style.position = "absolute"
    ta.style.left = "-9999px"
    document.body.appendChild(ta)
    ta.select()
    try { document.execCommand("copy") } catch (_e) { /* no-op */ }
    document.body.removeChild(ta)
    done()
  }

  flash() {
    if (!this.hasLabelTarget) return
    const original = this.labelTarget.textContent
    this.labelTarget.textContent = "Copied!"
    setTimeout(() => { this.labelTarget.textContent = original }, 1500)
  }
}
